var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    transform: "rotate(-180 13 13)",
    fill: "white",
    fillOpacity: 0.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.625,
    transform: "rotate(-180 13 13)",
    stroke: "#202124",
    strokeOpacity: 0.15,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13.1578 14.9961 13.2931 14.9452 13.4149 14.8394L16.8467 11.7914C16.9459 11.7013 17 11.5955 17 11.4662C17 11.2037 16.7655 11 16.4634 11C16.3191 11 16.1838 11.0509 16.08 11.141L13 13.8834L9.91996 11.141C9.81624 11.0509 9.68546 11 9.53664 11C9.2345 11 9 11.2037 9 11.4662C9 11.5916 9.05412 11.7013 9.15333 11.7914L12.5896 14.8394C12.7069 14.9491 12.8422 15 13 15Z",
    fill: "#202124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideZones);
export default __webpack_public_path__ + "static/media/hide-zones.75281a85bfa5c1676c56e03e23fe0eed.svg";
export { ForwardRef as ReactComponent };